export default '1.18.0';


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-md/es/Version.js
// module id = 1337
// module chunks = 0